import React from "react";
import { TextAreaField } from "../inputs";
import GenericFields from "./GenericFields";
import SignatureSection from "./SignatureSection";

export default function LetterOfCompletion() {
  return (
    <>
      <form
        method="POST"
        action="/student-request/letter-of-completion"
        onSubmit={() => {
          setSubmitting(true);
        }}
      >
        <GenericFields />

        <TextAreaField
          label="Please use the field below to provide the details needed to complete your letter of completion request."
          name="data[completion_details]"
          rows={5}
          required
        />

        <SignatureSection />
      </form>
    </>
  );
}
